import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { generateFilesDownloadUrl as universalGenerateFilesDownloadUrl, generateFileDownloadUrl as universalGenerateFileDownloadUrl, getFileDescriptor as universalGetFileDescriptor, getFileDescriptors as universalGetFileDescriptors, updateFileDescriptor as universalUpdateFileDescriptor, generateFileUploadUrl as universalGenerateFileUploadUrl, generateFileResumableUploadUrl as universalGenerateFileResumableUploadUrl, importFile as universalImportFile, bulkImportFiles as universalBulkImportFiles, bulkImportFile as universalBulkImportFile, listFiles as universalListFiles, searchFiles as universalSearchFiles, generateVideoStreamingUrl as universalGenerateVideoStreamingUrl, generateWebSocketToken as universalGenerateWebSocketToken, bulkDeleteFiles as universalBulkDeleteFiles, bulkRestoreFilesFromTrashBin as universalBulkRestoreFilesFromTrashBin, listDeletedFiles as universalListDeletedFiles, updateFile as universalUpdateFile, } from './media-site-media-v1-file-descriptor.universal';
import { MediaType, OperationStatus, State, Namespace, IdentityType, ContentDisposition, UploadProtocol, SortOrder, RootFolder, StreamFormat, WebhookIdentityType, } from './media-site-media-v1-file-descriptor.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.media.site_media.v1.file_descriptor', module_name: 'wix-media.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        generateFilesDownloadUrl: (fileIds) => {
            const methodLogData = {
                method_name: 'generateFilesDownloadUrl',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateFilesDownloadUrl',
            };
            return universalGenerateFilesDownloadUrl(fileIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateFileDownloadUrl: (fileId, options) => {
            const methodLogData = {
                method_name: 'generateFileDownloadUrl',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateFileDownloadUrl',
            };
            return universalGenerateFileDownloadUrl(fileId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getFileDescriptor: (fileId) => {
            const methodLogData = {
                method_name: 'getFileDescriptor',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.getFileDescriptor',
            };
            return universalGetFileDescriptor(fileId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getFileDescriptors: (fileIds) => {
            const methodLogData = {
                method_name: 'getFileDescriptors',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.getFileDescriptors',
            };
            return universalGetFileDescriptors(fileIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateFileDescriptor: (_id, options) => {
            const methodLogData = {
                method_name: 'updateFileDescriptor',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.updateFileDescriptor',
            };
            return universalUpdateFileDescriptor(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateFileUploadUrl: (mimeType, options) => {
            const methodLogData = {
                method_name: 'generateFileUploadUrl',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateFileUploadUrl',
            };
            return universalGenerateFileUploadUrl(mimeType, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateFileResumableUploadUrl: (mimeType, options) => {
            const methodLogData = {
                method_name: 'generateFileResumableUploadUrl',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateFileResumableUploadUrl',
            };
            return universalGenerateFileResumableUploadUrl(mimeType, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        importFile: (url, options) => {
            const methodLogData = {
                method_name: 'importFile',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.importFile',
            };
            return universalImportFile(url, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkImportFiles: (importFileRequests) => {
            const methodLogData = {
                method_name: 'bulkImportFiles',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.bulkImportFiles',
            };
            return universalBulkImportFiles(importFileRequests, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkImportFile: (importFileRequests, options) => {
            const methodLogData = {
                method_name: 'bulkImportFile',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.bulkImportFile',
            };
            return universalBulkImportFile(importFileRequests, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listFiles: (options) => {
            const methodLogData = {
                method_name: 'listFiles',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.listFiles',
            };
            return universalListFiles(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        searchFiles: (options) => {
            const methodLogData = {
                method_name: 'searchFiles',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.searchFiles',
            };
            return universalSearchFiles(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateVideoStreamingUrl: (fileId, options) => {
            const methodLogData = {
                method_name: 'generateVideoStreamingUrl',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateVideoStreamingUrl',
            };
            return universalGenerateVideoStreamingUrl(fileId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        generateWebSocketToken: () => {
            const methodLogData = {
                method_name: 'generateWebSocketToken',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.generateWebSocketToken',
            };
            return universalGenerateWebSocketToken(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteFiles: (fileIds, options) => {
            const methodLogData = {
                method_name: 'bulkDeleteFiles',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.bulkDeleteFiles',
            };
            return universalBulkDeleteFiles(fileIds, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkRestoreFilesFromTrashBin: (fileIds) => {
            const methodLogData = {
                method_name: 'bulkRestoreFilesFromTrashBin',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.bulkRestoreFilesFromTrashBin',
            };
            return universalBulkRestoreFilesFromTrashBin(fileIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listDeletedFiles: (options) => {
            const methodLogData = {
                method_name: 'listDeletedFiles',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.listDeletedFiles',
            };
            return universalListDeletedFiles(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateFile: (fileId, options) => {
            const methodLogData = {
                method_name: 'updateFile',
                service_name: 'com.wix.media.site_media.v1.FilesService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-media.v2,entity=wix.media.site_media.v1.file_descriptor,environment=velo-frontend,method-fqn=com.wix.media.site_media.v1.FilesService.updateFile',
            };
            return universalUpdateFile(fileId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        MediaType,
        OperationStatus,
        State,
        Namespace,
        IdentityType,
        ContentDisposition,
        UploadProtocol,
        SortOrder,
        RootFolder,
        StreamFormat,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=media-site-media-v1-file-descriptor.frontend.js.map